import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import WinPopup from '../../components/winPopUp';
import { winningStore } from '../../store/winningStore';
import { TableCardsSection } from '../../components/tableCardsSection';

export const GameSection = observer(() => {
  const { winningAmount } = winningStore;
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  return (
    <div className='tp-mid-web-right'>
      <div className='poker-table'>
        {!!winningAmount && (
          <WinPopup
            t={t}
            winningAmount={winningAmount}
            currencySymbolOrCode={currencySymbolOrCode}
          />
        )}
        <TableCardsSection />
      </div>
    </div>
  );
});
